var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"message-location",attrs:{"href":_setup.data.href,"target":"_blank","title":"点击查看详情"}},[_c('span',{staticClass:"el-icon-location-outline"},[_vm._v(_vm._s(_setup.data.description))]),_c('img',{attrs:{"src":_setup.data.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }